import { Grid, Paper,Container } from '@mui/material'
import React, { useEffect } from 'react'
import AdminTemplate from '../Components/Template/AdminTemplate'
import GalleryYearForm from '../Components/GalleryYearForm'
import GalleryYearInfo from '../Components/GalleryYearInfo'


function GalleryYear() {
 
    const GalleryYearScreen=()=>{
        return(
            <Container alignItems="center" sx={{mt:5}}>
            <Grid
           container
           spacing={5}
           direction="row"
           alignItems="center"
           justify="center"
           //style={{ minHeight: '100vh' }}
         >
                  <Grid item xs={12} md={5} lg={5}>
                  <Paper
                           sx={{
                             p: 2,
                             display: 'flex',
                             flexDirection: 'column',
                             height: "auto",
                           }}
                         >
                            <GalleryYearForm/>
                             {/* <StaffForm is_retire={false} staff_type={"teaching"}/> */}
                         </Paper>
                  </Grid>
                  <Grid item xs={12} md={7} lg={7}>
                  <Paper
                           sx={{
                             p: 2,
                             display: 'flex',
                             flexDirection: 'column',
                             height: "auto",
                           }}
                         >
                            <GalleryYearInfo/>
                          {/* <StaffInfo is_retire={false} staff_type={"teaching"}/> */}
                           
                         </Paper>
                  </Grid>
         
                 </Grid>
                 </Container>
        )
    }
  return (
  <AdminTemplate>
    {GalleryYearScreen()}
  </AdminTemplate>
  )
}

export default GalleryYear